import React, { useContext, useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import TimeLineTarget from "../TimeLine/TimeLineTarget";
import ComputerIcon from "@mui/icons-material/Computer";
import ChecklistIcon from "@mui/icons-material/Checklist";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import { ModalSolicitudCredito } from "../Modales/ModalSolicitudCredito";
import { LoaderScreen } from "../../components/LoaderScreen";
import { AnalisisCreditoContext } from "../AnalisisCreditoScreen";
import MdlSolicitudCreditoScreen from "../Modales/MdlSolicitudCreditoScreen";
import MdlValidacionPedido from "../Modales/MdlValidacionPedido";

import { AnalisisComentariosLine } from "../AnalisisComentariosLine";
import { AsignarPromotor } from "../JDF/AsignarPromotor";
import { AnalizarDocumentos } from "../JDF/AnalizarDocumentos";
import { GenerarSolicitudAnfexi } from "../JDF/GenerarSolicitudAnfexi";
import { Preanalisis } from "../JDF/Preanalisis";

import { Precalificacion } from "../JDF/Precalificacion";
import { IntegrarDocumeentos } from "../JDF/IntegrarDocumeentos";
import { ReportecampoJDF } from "../JDF/ReportecampoJDF";
import { DictamenJDF } from "../JDF/DictamenJDF";
import { FacturarEquipoJDF } from "../JDF/FacturarEquipoJDF";
import { AnalizarContrato } from "../JDF/AnalizarContrato";
import { ValidarFactura } from "../JDF/ValidarFactura";
import { ContratoJDF } from "../JDF/ContratoJDF";
import { CotejarInformacion } from "../JDF/CotejarInformacion";
import { Validardocumentos } from "../JDF/Validardocumentos";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { ValidarReporteCampo } from "../JDF/ValidarReporteCampo";
import { AutorizarFacturacion } from "../JDF/AutorizarFacturacion";
import { ValidarCondcionesOperacion } from "../CreditoMhusa/ValidarCondcionesOperacion";
import CommentIcon from "@mui/icons-material/Comment";
import TimelineIcon from '@mui/icons-material/Timeline';
import { CargarDocumentacionVendedor } from "../../Credito/CreditoCondicionado/CargarDcoumentacionVendedor";
import { ValidarCondicionesOperacionCondicionadaJDF } from "../JDF-Condicionado/ValidarCondicionesOperacionCondicionadaJDF";
import FacturarEquipoCondicionado from "../../Credito/CreditoCondicionado/FacturarEquipoCondicionado";
import { ModalComentariosJDF } from "../JDF-Condicionado/Modales/ModalComentariosJDF";

export const CreditoJohnDeereFinancial = ({ data, estado, upload, direccion }) => {
  const { state } = useContext(AnalisisCreditoContext);
  const [openSolicitud, setOpenSolicitud] = useState(false);
  const [comentarios, setComentario] = useState([]);
  const [mostrarCondicionado, setMostrarCondicionado] = useState(false);
  const [value, setValue] = useState(0);
  const [mostrarComentarios, setMostrarComentarios] = useState(false);
  const [valueCondicionado, setValueCondicionado] = useState(0);
  const [openSolicitudCondicionado, setOpenSolicitudCondicionado] = useState(false);
  const [dataCondicionado, setDataCondicionado] = useState({
    estado: {},
    detalle: [],
  });
  const [rechazoCondicionado, setRechazoCondicionado] = useState(false)
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  useEffect(() => {
    onActualizarComentarios();
    onCargarTimelineCondicionado()
  }, []);

  const onActualizarComentarios = () => {
    if (
      state.folio === undefined ||
      state.folio === null ||
      state.folio.length !== 13
    ) {
      return;
    }
    setLoader({ ...loader, mostrar: true });
    request
      .get(`AnalisisSolicitudCreditoComentarios/Listado?folio=${state.folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setComentario(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("ANALISIS DE SOLICITUD", JSON.stringify(error), "error");
      });
  };

  const onCargarTimelineCondicionado = () => {
    if (
      estado.folio_condicionado === undefined ||
      estado.folio_condicionado === null ||
      estado.folio_condicionado.length !== 13
    ) {
      return;
    }
    setLoader({ ...loader, mostrar: true });
    request
      .get(`SCCreditoCondicionado/CargarTimelineCondicionado?folio=${estado.folio_condicionado}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setDataCondicionado({
          estado: result.estado,
          detalle: result.detalle,
        });
        setMostrarCondicionado(true);
        // console.log(data)
        // if (data[11].habilitado === "False") {
        //     setMostrarCondicionado(true);

        // }
        // else {
        //     setMostrarCondicionado(false)
        // }
        if (result.detalle[2].estado === "Rechazado") {
          setRechazoCondicionado(true)
        }
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("ANALISIS DE SOLICITUD", JSON.stringify(error), "error");
      });
  }

  // Función para manejar la apertura de precalificacion
  const handleOpenComentarios = () => {
    setMostrarComentarios(true);
  };

  // Función para manejar el cierre de MdlValidacionPedidoJDF
  const handleCloseComentarios = () => {
    setMostrarComentarios(false);
  };

  const onCreditoCondicionado = () => {
    if (rechazoCondicionado === true) {
      return
    }
    else if (dataCondicionado.detalle.length !== 0) {
      setLoader({ ...loader, mostrar: true });
      const post = {
        folio: dataCondicionado.estado.folio,
        usuario: "",
      };
      request
        .post(`SCCreditoCondicionado/CancelarCondicionado`, post)
        .then(() => {
          setLoader({ ...loader, mostrar: false });
          setMostrarCondicionado(false);
          setDataCondicionado({ ...dataCondicionado, detalle: [] });
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("ANALISIS DE CREDITO", JSON.stringify(error), "error");
        });
      // setMostrarCondicionado(!mostrarCondicionado)
    }
    else {
      setLoader({ ...loader, mostrar: true });
      const post = {
        folio: state.folio,
        usuario: "",
      };
      request
        .post(`SCCreditoCondicionado/CrearCondicionado`, post)
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setDataCondicionado({
            estado: result.estado,
            detalle: result.detalle,
          });
          setMostrarCondicionado(true)
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("ANALISIS DE CREDITO", JSON.stringify(error), "error");
        });
    }
  };

  const onActualizarTimelineCondicionado = (folio) => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`SCCreditoCondicionado/CargarTimelineCondicionado?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setDataCondicionado({
          estado: result.estado,
          detalle: result.detalle,
        });
        if (result.detalle[2].estado === "Rechazado") {
          setRechazoCondicionado(true)
        }
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("ANALISIS DE SOLICITUD", JSON.stringify(error), "error");
      });
  }

  return (
    <PlantillaScreen
      titulo={"SOLICITUD DE CREDITO POR JOHN DEERE FINANCIAL"}
      className={"analisis-sc-procesos"}
    >
      <LoaderScreen loader={loader} />
      {mostrarComentarios && (
        <ModalComentariosJDF
          setOpenSolicitud={handleCloseComentarios}
          titulo={"COMENTARIOS"}
          estado={estado}
          comentarios={comentarios}
        />
      )}
      <ModalSolicitudCredito
        open={openSolicitud}
        setOpenSolicitud={setOpenSolicitud}
        upload={upload}
        value={value}
        setValue={setValue}
        maxValue={
          Number(estado.pantallacompleta) > 18
            ? 17
            : Number(estado.pantallacompleta)
        }
        screens={{
          screen0: (
            <MdlSolicitudCreditoScreen
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),
          screen1: (
            <MdlValidacionPedido
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              iddocumentopedido={55}
              updateComentarios={onActualizarComentarios}
            />
          ),
          screen2: (
            <ValidarCondcionesOperacion
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              iddocumentopedido={25}
              idproceso={7}
            />
          ),
          screen3: (
            <AsignarPromotor
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              updateComentarios={onActualizarComentarios}
            />
          ),
          screen4: (
            <AnalizarDocumentos
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              updateComentarios={onActualizarComentarios}
            />
          ),
          screen5: (
            <GenerarSolicitudAnfexi
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              updateComentarios={onActualizarComentarios}
            />
          ),
          screen6: (
            <Preanalisis
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              updateComentarios={onActualizarComentarios}
            />
          ),
          screen7: (
            <Validardocumentos
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              updateComentarios={onActualizarComentarios}
            />
          ),
          screen8: (
            <Precalificacion
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              updateComentarios={onActualizarComentarios}
            />
          ),
          screen9: (
            <ReportecampoJDF
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              updateComentarios={onActualizarComentarios}
            />
          ),
          screen10: (
            <ValidarReporteCampo
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              updateComentarios={onActualizarComentarios}
            />
          ),
          screen11: (
            <IntegrarDocumeentos
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              updateComentarios={onActualizarComentarios}
            />
          ),

          screen12: (
            <DictamenJDF
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              updateComentarios={onActualizarComentarios}
            />
          ),
          screen13: (
            <AutorizarFacturacion
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              updateComentarios={onActualizarComentarios}
              idproceso={22}
              responsable="J"
            />
          ),
          screen14: (
            <FacturarEquipoJDF
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              updateComentarios={onActualizarComentarios}
            />
          ),
          screen15: (
            <ValidarFactura
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              updateComentarios={onActualizarComentarios}
            />
          ),
          screen16: (
            <AnalizarContrato
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              updateComentarios={onActualizarComentarios}
            />
          ),

          screen17: (
            <ContratoJDF
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              updateComentarios={onActualizarComentarios}
            />
          ),
          screen18: (
            <CotejarInformacion
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              updateComentarios={onActualizarComentarios}
            />
          ),
        }}
        titulos={{
          screen0: "SOLICITUD DE CREDITO",
          screen1: "VALIDAR PEDIDO",
          screen2: "VALIDAR CONDICIONES DE LA OPERACION",
          screen3: "ASIGNAR PROMOTOR",
          screen4: "ANALIZAR DOCUMENTACION",
          screen5: "CAPTURAR SOLICITUD ANFEXI",
          screen6: "PREANALISIS",
          screen7: "VALIDAR DOCUMENTACION",
          screen8: "PRECALIFICACION",
          screen9: "REPORTE DE CAMPO",
          screen10: "VALIDAR REPORTE DE CAMPO",
          screen11: "INTEGRAR DOCUMENTACION ANFEXI",
          screen12: "DICTAMEN",
          screen13: "AUTORIZAR FACTURACION",
          screen14: "FACTURAR EQUIPO",
          screen15: "VALIDAR FACTURA",
          screen16: "ANALIZAR CONTRATO",
          screen17: "CARGAR CONTRATO",
          screen18: "CONTRATO FINALIZADO",
        }}
      />
      <div className="analisis-sc-procesos-timeline-header-container">
        <div className="analisis-sc-procesos-timeline-title-condicionado ">
          {state.cliente}
        </div>
        {/* {data[11].habilitado === "False" && (                )} */}
        <div className="analisis-sc-procesos-timeline-buttons-container">
          {mostrarCondicionado === true && (
            <div
              className="solicitud-credito-detalle-boton-comentarios"
              onClick={() => handleOpenComentarios()}
            >
              <CommentIcon /> Comentarios
            </div>
          )}

          {estado.habilitarcondicionado === true && direccion !== "V" && (
            <div
              className={
                mostrarCondicionado === false
                  ? "solicitud-credito-detalle-boton-timeline-condicionado"
                  : "solicitud-credito-detalle-boton-timeline-condicionado-rechazado"
              }
              onClick={() => onCreditoCondicionado()}
            >
              <TimelineIcon />{" "}
              {mostrarCondicionado === false
                ? "Crédito condicionado"
                : rechazoCondicionado === true
                  ? "Condicionado rechazado" : "Cancelar Condicionado"}
            </div>
          )}
        </div>


      </div>
      <div className="analisis-sc-procesos-timeline scroll-4">
        <TimeLineTarget
          icon={<ComputerIcon />}
          title={"Genero Solicitud"}
          subtitle={"Vendedor"}
          footer={{
            tiempoestimado: data[0].estado,
            leyenda: data[0].creado,
            duracion: data[0].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[0].control}
          active={1 === Number(estado.pantallacompleta)}
          value={0}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ChecklistIcon />}
          title={"Validar Pedido"}
          subtitle={"Gerente de sucursal"}
          footer={{
            tiempoestimado: data[1].estado,
            leyenda: data[1].creado,
            duracion: data[1].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[1].control}
          active={2 === Number(estado.pantallacompleta)}
          value={1}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ComputerIcon />}
          title={"Validar Condiciones Operación"}
          subtitle={"Coordinador Credito"}
          footer={{
            tiempoestimado: data[2].estado,
            leyenda: data[2].creado,
            duracion: data[2].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[2].control}
          active={3 === Number(estado.pantallacompleta)}
          value={2}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ManageSearchIcon />}
          title={"Asignar Promotor"}
          subtitle={"Coordinador JDF"}
          footer={{
            tiempoestimado: data[3].estado,
            leyenda: data[3].creado,
            duracion: data[3].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[3].control}
          active={4 === Number(estado.pantallacompleta)}
          value={3}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ManageSearchIcon />}
          title={"Analizar Documentación"}
          subtitle={"Promotor JDF"}
          footer={{
            tiempoestimado: data[4].estado,
            leyenda: data[4].creado,
            duracion: data[4].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[4].control}
          active={5 === Number(estado.pantallacompleta)}
          value={4}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<FactCheckIcon />}
          title={"Capturar Solicitud ANFEXI"}
          subtitle={"Promotor JDF"}
          footer={{
            tiempoestimado: data[5].estado,
            leyenda: data[5].creado,
            duracion: data[5].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[5].control}
          active={6 === Number(estado.pantallacompleta)}
          value={5}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<PriceCheckIcon />}
          title={"Preanalisis"}
          subtitle={"Promotor JDF"}
          footer={{
            tiempoestimado: data[6].estado,
            leyenda: data[6].creado,
            duracion: data[6].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[6].control}
          active={7 === Number(estado.pantallacompleta)}
          value={6}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<PriceCheckIcon />}
          title={"Validar Documentación"}
          subtitle={"Promotor JDF"}
          footer={{
            tiempoestimado: data[7].estado,
            leyenda: data[7].creado,
            duracion: data[7].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[7].control}
          active={8 === Number(estado.pantallacompleta)}
          value={7}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<PriceCheckIcon />}
          title={"Precalificación"}
          subtitle={"Promotor JDF"}
          footer={{
            tiempoestimado: data[8].estado,
            leyenda: data[8].creado,
            duracion: data[8].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[8].control}
          active={9 === Number(estado.pantallacompleta)}
          value={8}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<PriceCheckIcon />}
          title={"Reporte de Campo"}
          subtitle={"Promotor JDF"}
          footer={{
            tiempoestimado: data[9].estado,
            leyenda: data[9].creado,
            duracion: data[9].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[9].control}
          active={10 === Number(estado.pantallacompleta)}
          value={9}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<PriceCheckIcon />}
          title={"Validar Reporte de Campo"}
          subtitle={"Promotor JDF"}
          footer={{
            tiempoestimado: data[10].estado,
            leyenda: data[10].creado,
            duracion: data[10].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[10].control}
          active={11 === Number(estado.pantallacompleta)}
          value={10}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<PriceCheckIcon />}
          title={"Integrar Documentación ANFEXI"}
          subtitle={"Promotor JDF"}
          footer={{
            tiempoestimado: data[11].estado,
            leyenda: data[11].creado,
            duracion: data[11].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[11].control}
          active={12 === Number(estado.pantallacompleta)}
          value={11}
          setValue={setValue}
        />

        <TimeLineTarget
          icon={<PriceCheckIcon />}
          title={"Dictamen"}
          subtitle={"Promotor JDF"}
          footer={{
            tiempoestimado: data[12].estado,
            leyenda: data[12].creado,
            duracion: data[12].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[12].control}
          active={13 === Number(estado.pantallacompleta)}
          value={12}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<PriceCheckIcon />}
          title={"Autorizar Facturacion"}
          subtitle={"Gerencia Finanzas"}
          footer={{
            tiempoestimado: data[13].estado,
            leyenda: data[13].creado,
            duracion: data[13].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[13].control}
          active={14 === Number(estado.pantallacompleta)}
          value={13}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<PriceCheckIcon />}
          title={"Facturar Equipo"}
          subtitle={"Ventas"}
          footer={{
            tiempoestimado: data[14].estado,
            leyenda: data[14].creado,
            duracion: data[14].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[14].control}
          active={15 === Number(estado.pantallacompleta)}
          value={14}
          setValue={setValue}
        />

        <TimeLineTarget
          icon={<PriceCheckIcon />}
          title={"Validar Factura"}
          subtitle={"Promotor JDF"}
          footer={{
            tiempoestimado: data[15].estado,
            leyenda: data[15].creado,
            duracion: data[15].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[15].control}
          active={16 === Number(estado.pantallacompleta)}
          value={15}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<PriceCheckIcon />}
          title={"Analizar Contrato"}
          subtitle={"Promotor JDF"}
          footer={{
            tiempoestimado: data[16].estado,
            leyenda: data[16].creado,
            duracion: data[16].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[16].control}
          active={17 === Number(estado.pantallacompleta)}
          value={16}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<PriceCheckIcon />}
          title={"Cargar Contrato"}
          subtitle={"Promotor JDF"}
          footer={{
            tiempoestimado: data[17].estado,
            leyenda: data[17].creado,
            duracion: data[17].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[17].control}
          active={18 === Number(estado.pantallacompleta)}
          value={17}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<PriceCheckIcon />}
          title={"Contrato Finalizado"}
          subtitle={"Promotor JDF"}
          footer={{
            tiempoestimado: data[18].estado,
            leyenda: data[18].creado,
            duracion: data[18].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[18].control}
          active={19 === Number(estado.pantallacompleta)}
          value={18}
          setValue={setValue}
          endtarget={true}
        />
      </div>

      {mostrarCondicionado === false && (
        <AnalisisComentariosLine
          tiempotranscurrido={estado.tiempotranscurrido}
          tiempoestimado={estado.tiempoestimado}
          comentarios={comentarios}
        />
      )}

      <ModalSolicitudCredito
        open={openSolicitudCondicionado}
        setOpenSolicitud={setOpenSolicitudCondicionado}
        upload={upload}
        value={valueCondicionado}
        setValue={setValueCondicionado}
        maxValue={
          Number(dataCondicionado.estado.pantallacompleta) > 3
            ? 4
            : Number(dataCondicionado.estado.pantallacompleta)
        }
        screens={{
          screen0: (
            <MdlSolicitudCreditoScreen
              folio={estado.folio_condicionado === null ? dataCondicionado.estado.folio : estado.folio_condicionado}
              setLoader={setLoader}
              loader={loader}
            />
          ),
          screen1: (
            <CargarDocumentacionVendedor
              folio={estado.folio_condicionado === null ? dataCondicionado.estado.folio : estado.folio_condicionado}
              setLoader={setLoader}
              loader={loader}
              idproceso={100}
              upload={onActualizarTimelineCondicionado}
            />
          ),
          screen2: (
            <ValidarCondicionesOperacionCondicionadaJDF
              folio={estado.folio_condicionado === null ? dataCondicionado.estado.folio : estado.folio_condicionado}
              setLoader={setLoader}
              loader={loader}
              upload={upload}
            />
          ),
          screen3: (
            <FacturarEquipoCondicionado
              folio={estado.folio_condicionado === null ? dataCondicionado.estado.folio : estado.folio_condicionado}
              setLoader={setLoader}
              loader={loader}
              upload={onActualizarTimelineCondicionado}
            />
          ),
        }}
        titulos={{
          screen1: "OPERACION CONDICIONADA",
          screen2: "VALIDAR CONDICIONES",
          screen3: "FACTURAR EQUIPO",
        }}
      />

      {/* <ModalSolicitudCredito
                open={openSolicitudCondicionado}
                setOpenSolicitud={setOpenSolicitudCondicionado}
                upload={upload}
                value={valueCondicionado}
                setValue={setValueCondicionado}
                maxValue={
                    Number(dataCondicionado.estado.pantallacompleta) > 8
                        ? 9
                        : Number(dataCondicionado.estado.pantallacompleta)
                }
                screens={{
                    screen0: (
                        <MdlSolicitudCreditoScreen
                            folio={estado.folio_condicionado === null ? dataCondicionado.estado.folio_condicionado : estado.folio_condicionado}
                            setLoader={setLoader}
                            loader={loader}
                        />
                    ),
                    screen1: (
                        <CargarDocumentacionVendedor
                            folio={estado.folio_condicionado === null ? dataCondicionado.estado.folio_condicionado : estado.folio_condicionado}
                            setLoader={setLoader}
                            loader={loader}
                            idproceso={100}
                            upload={onActualizarTimelineCondicionado}
                        />
                    ),
                    screen2: (
                        <ValidarCondicionesOperacionCondicionadaJDF
                            folio={estado.folio_condicionado === null ? dataCondicionado.estado.folio_condicionado : estado.folio_condicionado}
                            setLoader={setLoader}
                            loader={loader}
                            upload={upload}
                        />
                    ),
                    screen3: (
                        <FacturarEquipoCondicionado
                            folio={estado.folio_condicionado === null ? dataCondicionado.estado.folio_condicionado : estado.folio_condicionado}
                            setLoader={setLoader}
                            loader={loader}
                            upload={onActualizarTimelineCondicionado}
                        />
                    ),
                    screen4: (
                        <CargarPagareEquipCondicionado
                            folio={estado.folio_condicionado === null ? dataCondicionado.estado.folio_condicionado : estado.folio_condicionado}
                            setLoader={setLoader}
                            loader={loader}
                            upload={onActualizarTimelineCondicionado}
                        />
                    ),
                    screen5: (
                        <CargarDocumentacionAprobadaCondicionado
                            folio={estado.folio_condicionado === null ? dataCondicionado.estado.folio_condicionado : estado.folio_condicionado}
                            setLoader={setLoader}
                            loader={loader}
                            idproceso={30}
                            upload={onActualizarTimelineCondicionado}
                        />
                    ),
                    screen6: (
                        <AnalizarDocumentacionAprobadaCondicionado
                            folio={estado.folio_condicionado === null ? dataCondicionado.estado.folio_condicionado : estado.folio_condicionado}
                            setLoader={setLoader}
                            loader={loader}
                            idproceso={30}
                            upload={onActualizarTimelineCondicionado}
                        />
                    ),
                    screen7: (
                        <FinalizaJDFCondicionado
                            folio={estado.folio_condicionado === null ? dataCondicionado.estado.folio_condicionado : estado.folio_condicionado}
                            setLoader={setLoader}
                            loader={onActualizarTimelineCondicionado}
                        />
                    ),

                }}
                titulos={{
                    screen1: "OPERACION CONDICIONADA",
                    screen2: "VALIDAR CONDICIONES",
                    screen3: "FACTURAR EQUIPO",
                    screen4: "CARGAR PAGARE EQUIP",
                    screen5: "CARGAR DOCUMENTACION",
                    screen6: "ANALIZAR DOCUMENTACION",
                    screen7: "FINALZIAR SOLICITUD",
                }}
            /> */}

      {mostrarCondicionado === true && (
        <div className="analisis-credito-tiempos-condicionado-container">
          <div className="analisis-credito-comentarios-header-condicionado">
            <div className="analisis-credito-comentarios-header-comentarios-condicionado">
              <CommentIcon />
              TIMELINE CONDICIONADO
            </div>
          </div>
          {/* <div className="separacion"></div> */}

          <div className="analisis-sc-procesos-timeline-condicionado scroll">

            <TimeLineTarget
              icon={<ComputerIcon />}
              title={"Operacion condicionada"}
              subtitle={"Gerente de linea"}
              footer={{
                tiempoestimado: dataCondicionado.detalle[1].estado,
                leyenda: dataCondicionado.detalle[1].creado,
                duracion: dataCondicionado.detalle[1].tiempoestimado,
                comentarios: "",
              }}
              openModal={setOpenSolicitudCondicionado}
              color={dataCondicionado.detalle[1].control}
              active={2 === Number(dataCondicionado.estado.pantallacompleta)}
              value={1}
              setValue={setValueCondicionado}
            // seleccionado={seleccionado}
            // setSeleccionado={setSeleccionado}
            />
            <TimeLineTarget
              icon={<ComputerIcon />}
              title={"Validar condiciones"}
              subtitle={"Gerente de finanzas"}
              footer={{
                tiempoestimado: dataCondicionado.detalle[2].estado,
                leyenda: dataCondicionado.detalle[2].creado,
                duracion: dataCondicionado.detalle[2].tiempoestimado,
                comentarios: "",
              }}
              openModal={setOpenSolicitudCondicionado}
              color={dataCondicionado.detalle[2].control}
              active={3 === Number(dataCondicionado.estado.pantallacompleta)}
              value={2}
              setValue={setValueCondicionado}
            // seleccionado={seleccionado}
            // setSeleccionado={setSeleccionado}
            />
            <TimeLineTarget
              icon={<ComputerIcon />}
              title={"Facturar equipo"}
              subtitle={"Cajera"}
              footer={{
                tiempoestimado: dataCondicionado.detalle[3].estado,
                leyenda: dataCondicionado.detalle[3].creado,
                duracion: dataCondicionado.detalle[3].tiempoestimado,
                comentarios: "",
              }}
              openModal={setOpenSolicitudCondicionado}
              color={dataCondicionado.detalle[3].control}
              active={4 === Number(dataCondicionado.estado.pantallacompleta)}
              value={3}
              setValue={setValueCondicionado}
              endtarget={true}
            // seleccionado={seleccionado}
            // setSeleccionado={setSeleccionado}
            />
            {/* <TimeLineTarget
                        icon={<ComputerIcon />}
                        title={"Cargar pagare Equip"}
                        subtitle={"Cajera"}
                        footer={{
                            tiempoestimado: dataCondicionado.detalle[4].estado,
                            leyenda: dataCondicionado.detalle[4].creado,
                            duracion: dataCondicionado.detalle[4].tiempoestimado,
                            comentarios: "",
                        }}
                        openModal={setOpenSolicitudCondicionado}
                        color={dataCondicionado.detalle[4].control}
                        active={5 === Number(dataCondicionado.estado.pantallacompleta)}
                        value={4}
                        setValue={setValueCondicionado}
                    // seleccionado={seleccionado}
                    // setSeleccionado={setSeleccionado}
                    />
                    <TimeLineTarget
                        icon={<ComputerIcon />}
                        title={"Cargar documentación"}
                        subtitle={"Gerente de linea"}
                        footer={{
                            tiempoestimado: dataCondicionado.detalle[5].estado,
                            leyenda: dataCondicionado.detalle[5].creado,
                            duracion: dataCondicionado.detalle[5].tiempoestimado,
                            comentarios: "",
                        }}
                        openModal={setOpenSolicitudCondicionado}
                        color={dataCondicionado.detalle[5].control}
                        active={6 === Number(dataCondicionado.estado.pantallacompleta)}
                        value={5}
                        setValue={setValueCondicionado}
                    // seleccionado={seleccionado}
                    // setSeleccionado={setSeleccionado}
                    />
                    <TimeLineTarget
                        icon={<ComputerIcon />}
                        title={"Analizar documentación"}
                        subtitle={"Gerente de finanzas"}
                        footer={{
                            tiempoestimado: dataCondicionado.detalle[6].estado,
                            leyenda: dataCondicionado.detalle[6].creado,
                            duracion: dataCondicionado.detalle[6].tiempoestimado,
                            comentarios: "",
                        }}
                        openModal={setOpenSolicitudCondicionado}
                        color={dataCondicionado.detalle[6].control}
                        active={7 === Number(dataCondicionado.estado.pantallacompleta)}
                        value={6}
                        setValue={setValueCondicionado}
                    // seleccionado={seleccionado}
                    // setSeleccionado={setSeleccionado}
                    />
                    <TimeLineTarget
                        icon={<ComputerIcon />}
                        title={"Finalizar solicitud"}
                        subtitle={"Gerente de finanzas"}
                        footer={{
                            tiempoestimado: dataCondicionado.detalle[7].estado,
                            leyenda: dataCondicionado.detalle[7].creado,
                            duracion: dataCondicionado.detalle[7].tiempoestimado,
                            comentarios: "",
                        }}
                        openModal={setOpenSolicitudCondicionado}
                        color={dataCondicionado.detalle[7].control}
                        active={8 === Number(dataCondicionado.estado.pantallacompleta)}
                        value={7}
                        setValue={setValueCondicionado}
                        endtarget={true}
                    // seleccionado={0}
                    // setSeleccionado={setSeleccionado}
                    /> */}
          </div>
        </div>
      )}

    </PlantillaScreen>
  );
};
